const chuck_img = {'image': 'https://cdn.shopify.com/s/files/1/0299/5411/3669/t/11/assets/chuck-in-cart-no-bubbles.png?v=2441228424905278583'};
const fby_min = 2;

const atccb_the_host = window.location.hostname;
const atccb_api_host = atccb_the_host.includes('dev') ? 'staging' : 'production';
const atccb_api_base = `https://${atccb_api_host}.tezcatlipoca.apps.creativity.inc/s/atc`;
let drawer_recent_prod_id;

// Put your application javascript here //


// Free Item Promos
// companion-script-promo.liquid sets thresholds based on shop metafields
// ----------------------------------------------------------------------------------------

// Add and remove free items for each threshold
function runFreeItemPromo(cart = CartJS.cart) {

  if(typeof thresholds !== 'undefined'){
    thresholds.forEach((item) => {
        addFreeItems(cart, item.threshold, item.variant_id);        
        removeFreeItems(cart, item.threshold, item.variant_id);
      });

    // reload cart if the free item was added
    if(document.getElementById('shopping_cart')) {
        drawCart(cart)
    }
  }
}

// Add free items if cart is over a threshold amount
function addFreeItems(cart, threshold, variant) {
    if (promoIsActive === false) return false;

    let cartTotal = cart.total_price;
    let freeItem = cart.items.map((i) => i.id === variant && i.properties.hasOwnProperty('_is_free_item'));

    let giftRemoved = sessionStorage.getItem(`giftRemoved_${variant}`);

    // Add free gift if customer did not remove it themselves within the same session
    if (giftRemoved !== 'true') {
        if (cartTotal >= threshold) {
            if (freeItem.includes(true)) {
                return false;
            } else {
                CartJS.addItem(variant, 1, {
                    _is_free_item: true,
                });
            }
        } else {
            return false;
        }
    }
}

// Remove free items from cart if total is below thresholds
// only removes the item that was automatically added by the addFreeItems function
function removeFreeItems(cart, threshold, variant) {
    if (promoIsActive === false) {
        return false;
    }

    let cartTotal = cart.total_price;
    let freeItem = cart.items.find((i) => i.id === variant && i.properties.hasOwnProperty('_is_free_item'));
  
    if (cartTotal < threshold) {
      if (freeItem) {
        CartJS.removeItemById(freeItem.key);
      }
    } else {
      return false;
    }
}


// Cart Counter
// ----------------------------------------------------------------------------------------
function updateCartCounter(cart = CartJS.cart) {
    let item_count = 0;
    const sku_check = ['FBY', 'MQ', 'TRIM', 'QB'];
    
    for (let i = 0; i < cart.items.length; i++) {
        const item = cart.items[i];
        
        let sku_found = 0;
        
        for (let sku = 0; sku < sku_check.length; sku++) {
            const sku_item = sku_check[sku];
            sku_found = sku_found + item.sku.includes(sku_item)
        }

        ( sku_found ) ? item_count++ : item_count = item_count + item.quantity;
        
        if (item.sku.includes('FBY') && item.quantity < fby_min) {
            CartJS.updateItemById(item.key, fby_min, item.properties, item.options);
        }
    }

    if(item_count) {
        // Update all locations of cart icon to display count of items in cart
        document.querySelectorAll('.cart-item-count').forEach(i => {
            i.innerText = item_count
            i.classList.remove('hidden');
        });
    }else{
        // Update all locations of cart icon to hide count badge
        document.querySelectorAll('.cart-item-count').forEach(i => {
            i.classList.add('hidden');
        });
    }
}

// Update cart badge count on load
// ----------------------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', function() {

    runFreeItemPromo();
    updateCartCounter();

    if(localStorage.getItem('CookiePolicyAccepted') === null) {
        // add negative margin for mobile devices
        let bottom_class = "";
        let cookie_clicker = `<svg class="w-6 h-6 cursor-pointer" onclick="document.getElementById('enjoySomeCookies').remove();" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle fill-opacity=".5" fill="#697175" cx="6" cy="6" r="6"></circle><path d="M3.75 3.75l4.596 4.596M8.25 3.75L3.654 8.346" stroke="#fff" stroke-linecap="square"></path></g></svg>`;

        if($(window).width() <= 640) {
            bottom_class = 'cookie-mobile-margin';
            cookie_clicker = `<svg class="w-6 h-6 cursor-pointer text-gray-200 text-current fill-current transform" onclick="document.getElementById('enjoySomeCookies').classList.toggle('${bottom_class}'); this.classList.toggle('rotate-180');" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 125" xml:space="preserve"><path d="M50 5C25.251 5 5 25.251 5 50s20.251 45 45 45 45-20.251 45-45S74.749 5 50 5zm27.001 50.999c-3 2.252-7.127 1.501-10.126-1.124l-8.251-8.251H57.5V72.5c0 4.124-3.376 7.5-7.5 7.5s-7.5-3.376-7.5-7.5v-27l-9.749 9.752c-3.003 2.999-7.877 2.999-10.503 0-3-3.003-3-7.5 0-10.503l22.126-22.5C45.876 20.75 47.751 20 49.626 20s3.75.75 5.248 2.249l22.877 22.5c3.373 3.376 3 8.627-.75 11.25z" /></svg>`;
        }

        $(`<div id="enjoySomeCookies" style="z-index: 40000;" class="${bottom_class} transform transition ease-in-out delay-75 bg-aqua text-white rounded-lg w-full md:w-2/5 fixed bottom-0 py-6 px-8 md:mx-12 md:my-4">
            <div class="flex justify-between">
                <div class="text-xl font-bold">We Use Cookies 🍪</div>
                <div>${cookie_clicker}</div>
            </div>
            <div class="text-lg">
                to make sure the website can function, to measure traffic and to support the marketing of our services. By using the website, you agree to our use of cookies. Please read our privacy policy for further information about our use of cookies. 
            </div>
            <div class="flex justify-center items-center">
                <button onclick="localStorage.setItem('CookiePolicyAccepted', true); document.getElementById('enjoySomeCookies').remove();" class="msqc-btn text-white py-2 px-8 sm:px-12 text-lg my-4 focus:outline-none focus:shadow-none">Accept</button>
            </div>
        </div>`).prependTo('body')
    }

});

// Add item to cart on click
// ----------------------------------------------------------------------------------------
function addToCart(item_id, item_qty = 1, properties = {}, add_src = false, atccb = false) {
    if(CartJS.getAttributes().hasOwnProperty('_bundle_bound')) {
        properties = {...properties, ...{'_bundle_bound': 'true'}};
    }

    CartJS.addItem(item_id, item_qty, properties,
        {
            "success": function(data, textStatus, jqXHR) {
                updateCartCounter();
                if(typeof thresholds !== 'undefined'){
                    thresholds.forEach((item) => {
                        addFreeItems(CartJS.cart, item.threshold, item.variant_id);
                        // reset gift removal state if customer adds a free item back themselves
                        let keys = Object.keys(sessionStorage);
                        let found = keys.find(key => key === `giftRemoved_${item_id}`);
                        if (found) {
                            sessionStorage.removeItem(`giftRemoved_${item_id}`); 
                        }
                    });
                }

                dataLayer.push({'event': 'AddToCart'});
                if(add_src) gtag('event', add_src);

                if(atccb !== false) {
                    $.ajax({
                        url: `${atccb_api_base}?${atccb}`,
                        method: 'GET'
                    }).done(function (response) {
                        return response;
                    }).fail(function (error) {
                        console.error(error);
                    });
                }

                if(document.getElementById('drawer-curtain') !== null){
                    drawer_recent_prod_id = item_id;
                    showDrawer(item_id);
                }else{
                    notification(textStatus, data.title + ' has been added to your cart.', data);
                }
            },
            "error": function(jqXHR, textStatus, errorThrown){
                notification(textStatus, jqXHR.responseJSON.description, chuck_img);
            }
        }
        
    );
}

// Update an item already in the cart
function updateCartItem(item, qty, props = {}) {
    CartJS.updateItemById(
        item.key, qty, props,
        {
            "success": function(data, textStatus, jqXHR){
                updateCartCounter();

                //remove session variable for adding free gift back to cart from PDP
                let keys = Object.keys(sessionStorage);
                let selected = item.id; // $('#selected_variant').val();
            
                let found = keys.find(key => key === `giftRemoved_${selected}`);
                if (found) {
                    sessionStorage.removeItem(`giftRemoved_${selected}`); 
                }

                if(document.getElementById('drawer-curtain') !== null){
                    drawer_recent_prod_id = item.id;
                    showDrawer(item.id);
                }else{
                    notification(textStatus, item.product_title + ' has been updated in your cart.', data.items.find(item => item.variant_id === item.id))
                }
                
            },
            "error": function(jqXHR, textStatus, errorThrown){
                notification(textStatus, jqXHR.responseJSON.description, current_item);
            }
        }
    );
}

/* Working on a solution to add multiple items in a single click */
function addGroupToCart(){
    let cartItems = [];

    document.getElementById('msqc-fproducts').children.forEach(i => { 
        if (i.dataset.available == 'true') {
            let jsonData = {}; 
            jsonData.id = parseInt(i.dataset.productid); 
            jsonData.quantity = parseInt(i.dataset.quantity); 
            cartItems.push(jsonData);
        }
    });

    CartJS.addItems(
        cartItems,
        {
            "success": function(data, textStatus, jqXHR) {
                notification(textStatus, 'All the available supplies have been added to your cart.', chuck_img);
            },
            "error": function(jqXHR, textStatus, errorThrown) {
                notification(textStatus, jqXHR.responseJSON.description, chuck_img);
            }
        }
    );    
}

// Toggle Transcript Collapsing
// ----------------------------------------------------------------------------------------
function toggleTranscript(e) {
    document.querySelector('#p_transcript').classList.toggle('h-64');

    if (document.getElementById('p_transcript').classList.contains('h-64')){
        document.getElementById('p_collapse').text = 'Read more';
    } else {
        document.getElementById('p_collapse').text = 'Read less';
    }
    
}
// Cart Spinner
// ----------------------------------------------------------------------------------------
$(document).on('cart.requestStarted', function(e, c){
    if ($('#cart_spinner').length) {
        $('#cart_spinner').addClass('animate-spin');
        notification('success', 'Your cart is being updated', chuck_img);
    }
});

$(document).on('cart.requestComplete', function(e, c) {

        updateCartCounter(c);
        runFreeItemPromo(c);

        if(typeof Zowie !== 'undefined'){
            Zowie.updateCart();
        }
    
        if (typeof window.loyaltylion != "undefined" && typeof window.loyaltylion.ui != "undefined") {
            window.loyaltylion && window.loyaltylion.ui.refresh();
        }

        if (typeof free_shipping_countdown === 'function') {
            free_shipping_countdown(c);
        }

        if ($('#cart_spinner').length) {
            $('#cart_spinner').removeClass('animate-spin');
        }

        if(typeof drawDrawer !== 'undefined' && drawer_recent_prod_id){
            drawDrawer(drawer_recent_prod_id);
        }

        if(typeof updateLLPoints !== 'undefined'){
            updateLLPoints();
        }

        // check if cart is empty, remove bundle_bound checks
        if(c.item_count === 0 && c.attributes._bundle_bound){
            CartJS.setAttributes({
                '_bundle_bound': '',
                '_bundle_total': ''
            });
            CartJS.setNote(null);
        }
});

// Add to cart notification
// ----------------------------------------------------------------------------------------
function notification(type, title, product) {
    
    let hasTime = null;

    let toast_id = `toast-${Math.random().toString(36).slice(2)}`;

    const default_zindex = 1000000099;
    let toast_z = default_zindex + parseInt($('.toaster').length);

    let exclude_from_cart = "";
    if(window.location.href.indexOf('cart') === -1){
        exclude_from_cart = `<div class="text-sm"><a href="/cart" class="text-orange hover:text-underline">View your cart</a></div>`;
    }

    // build div
    $(`<div id="${toast_id}" class="toaster animate__animated hidden fixed bottom-0 w-full md:w-auto md:right-0 md:mb-8 md:mr-8 md:shadow-xl md:rounded-lg bg-white" style="z-index: ${toast_z};">
        <div class="toast_box flex justify-start items-center ml-0 sm:px-4 sm:py-4 md:pr-0 md:pl-0 md:py-0 border-l-8 md:border-l-4 md:border-r-4 md:rounded-lg">
            <img src="${product.image}" alt="${product.title}" class="h-24 w-auto p-3 rounded-l-8" />
            <div class="ml-4">
                <div class="toast_title">${title}</div>
                <div class="toast_cart_info mt-2 text-xs"><span class="toast-cart-total">{ cart.total }</span> x <span class="cart-item-count">{ cart.items }</span> items</div>
                ${exclude_from_cart}
            </div>
            <div class="toast_close self-stretch px-2 ml-4">&nbsp;</div>
        </div>
    </div>`).prependTo('body');
    
    $(`#${toast_id} .toast-cart-total`).text(Shopify.formatMoney(CartJS.cart.total_price)); // Show cart total

    // Set notification colors
    if( type === 'success') {
        $(`#${toast_id} .toast_box`).removeClass('border-red').addClass('border-aqua');
        $(`#${toast_id} .toast_cart_info`).hide();
    } else {
        $(`#${toast_id} .toast_box`).removeClass('border-aqua').addClass('border-red');
        $(`#${toast_id} .toast_cart_info`).hide();
    }

    const toaster = document.querySelector(`#${toast_id}`);

    // Show notification
    if (toaster.classList.contains('hidden') || toaster.classList.contains('animate__fadeOutRight')) {
        // remove classes and show toaster
        toaster.classList.add('animate__fadeInRight');
        toaster.classList.remove('hidden', 'animate__fadeOutRight');
        
        if(hasTime != null){
            clearTimeout(hasTime)
        }
        // hide notification
        hasTime = setTimeout(function() {
            toaster.classList.remove('animate__fadeInRight');
            toaster.classList.add('animate__fadeOutRight');

            toaster.addEventListener('animationend', () => {
                $(`#${toast_id}`).remove();
            });
            return false;
        }, 5000);
    }
}
